export default {
    name: "Delete",
    title: "Delete",
    icon: "mdi-delete-alert-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            component: null,
        };
    },
};